const ADD_OPERATION = "ADD";
const CHANGE_OPERATION = "CHANGE";
const UPDATE_OPERATION = "UPDATE";
const CART_TYPE = "CART";
const CART_HTML_TYPE = "CART_HTML";

function performCartOperation(cartData, callback, operationType = ADD_OPERATION, bundleAdd) {
  var url = "/cart/add.js";
  var method = operationType.includes(CART_TYPE) ? "GET" : "POST";
  if (document.querySelector('cart-items') == null && (document.querySelector('cart-notification') || document.querySelector('cart-drawer'))) {
    var cartEle = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = cartEle.getSectionsToRender().map((section) => section.id);
  } else if (document.querySelector('cart-items')) {
    var cartEle = document.querySelector('cart-items');
    var sections = cartEle.getSectionsToRender().map((section) => section.section);
  }
  
  cartData['sections'] = sections;

  if (operationType === CHANGE_OPERATION) {
    url = "/cart/change.js";
  } else if (operationType === UPDATE_OPERATION) {
    url = "/cart/update.js";
  } else if (operationType === CART_TYPE) {
    url = "/cart.js";
  } else if (operationType === CART_HTML_TYPE) {
  }
  var requestOptions = {
    method: method,
    credentials: "same-origin",
    headers: {
      "Content-Type": operationType.includes("HTML") ? "text/html" : "application/json",
      "X-Requested-With": "xmlhttprequest",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      "Pragma": "no-cache",
      "Expires": 0
    },
    body: cartData && JSON.stringify(cartData)
  };

  return fetch(url, requestOptions)
    .then(response => response.text())
    .then(data => {
      var responseData = JSON.parse(data);
      // if (responseData.status) {
      //     throw new Error(responseData.description);
      // }
      if (bundleAdd) {
        addRemoveGiftsFromCart(callback);
      } else if (typeof callback != 'undefined') {
        callback(responseData);
      }
    })
    .catch(error => {
      console.error(error);
    });
}
function addCartItems(cartItems, callback, bundleAdd) {
  return performCartOperation({ items: cartItems }, callback, ADD_OPERATION, bundleAdd);
}
function updateCartItems(cartUpdates, callback) {
  return performCartOperation({ updates: cartUpdates }, callback, UPDATE_OPERATION);
}
function isProductInCart(cartProduct, productId) {
  if (typeof cartProduct != 'undefined') {
    return cartProduct.some(function (item) {
      return item.id === parseInt(productId, 10);
    });
  }
}

function isProductInCart(cartProduct, productId) {
  if (typeof cartProduct != 'undefined') {
    return cartProduct.some(function (item) {
      return item.id === parseInt(productId, 10);
    });
  }
}
function isGiftProductInCart(cartProduct, productId) {
  if (typeof cartProduct != 'undefined') {
    return cartProduct.some(function (item) {
      return item.id === parseInt(productId, 10) && item.properties['_free'] == 'yes';
    });
  }
}

function addRemoveGiftsFromCart(callback) {
  if (window.GWP != undefined && typeof window.GWP.product != 'undefined' && typeof window.GWP.product.error == 'undefined') {
    $.getJSON('/cart.js', function(data) {
      var cart = data;
      var cartProduct = cart.items;
      var giftProduct = window.GWP.product.split(',');
      var toAdd = [];
      var toRemove = [];
      var toUpdate = [];
      if (typeof cartProduct != 'undefined' && cart.item_count > 0) {
        var checkNeedGift = cartProduct.filter(function(v, i) {
          return v.properties != null && typeof v.properties['_bundleId'] != 'undefined' && typeof v.properties['_box'] != 'undefined';
        });

        var bundleCount = 0;
        $(checkNeedGift).each(function(i, v) {
          bundleCount = bundleCount + v.quantity;
        });
        var totalCount = 0;
        if (checkNeedGift.length > 0) {
          var totalCount = checkNeedGift[0].properties['_box'];
        }
        if (checkNeedGift.length > 0 && bundleCount >= totalCount) {
          $(giftProduct).each(function(i, v) {
            var isInCart = isGiftProductInCart(cartProduct, v);
            if (!isInCart) {
              toAdd.push({
                quantity: 1,
                id: v,
                properties: {
                  '_free': 'yes'
                }
              });
            }
          });
        } else if ((checkNeedGift.length > 0 && bundleCount < totalCount) || checkNeedGift.length == 0) {
          
          var cartEle = document.querySelector('cart-notification') || document.querySelector('cart-items') || document.querySelector('cart-drawer');
          var sections = cartEle.getSectionsToRender().map((section) => section.id);
          $(giftProduct).each(function(i, v) {
            var isGift = cart.items.filter(function(p, q) {
              return v == p.id && p.properties['_free'] == 'yes';
            });
            var isInCart = isProductInCart(cartProduct, v);
            if (isGift.length > 0) {
              toRemove.push(isGift[0]);
            }
          });
          var payload = {
            toRemove,
            sections
          };
        }
        if (toAdd.length) {
          if (typeof callback != 'undefined') {
            addCartItems(toAdd, callback, false);
          } else {
            addCartItems(toAdd);
          }
        }
        if (toRemove.length) {
          const items = toRemove.reduce((accumulator, currentItem) => {
            accumulator[currentItem.key] = 0;
            return accumulator;
          }, {});
          if (typeof callback != 'undefined') {
            updateCartItems(items, callback);
          } else {
            updateCartItems(items);
          }
        }
      }
      if (toRemove.length == 0 && toAdd.length == 0 && typeof callback != 'undefined') {
        callback();
      }
    })
  } else {
    callback();
  }
}

var removeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-remove">
  <path d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z" fill="currentColor"/>
</svg>`;
var plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-plus">
  <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill="currentColor"/>
</svg>`;
var minusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon icon-minus">
  <path d="M5 13V11H19V13H5Z" fill="currentColor"/>
</svg>`;

function addProductHtml() {
  var html = '';
  var reviewHtml = '';
  var totalQty = 0;
  var packLimit = parseInt($('[data-subscription-collection]').attr('data-cuts'));
  $('[data-subscription-collection] .subscription-qty-input').each(function(i, v) {
    var qty = parseInt($(this).val());
    totalQty += qty;
  });
  var totalPrice = 0;
  $('[data-subscription-collection] .subscription-qty-input').each(function(i, v) {
    var qty = parseInt($(this).val());
    var parent = $(this).parents('.subscription-card-product');
    var product = JSON.parse(parent.find('[type="application/json"]').text())[0];
    var qtyPrice = qty * product.price;
    totalPrice += qtyPrice;
  });
  var count = 0;
  $('[data-subscription-collection] .subscription-qty-input').each(function(i, v) {
    var qty = parseInt($(this).val());
    var parent = $(this).parents('.subscription-card-product');
    var data = JSON.parse(parent.find('[type="application/json"]').text());
    var product = JSON.parse(parent.find('[type="application/json"]').text())[0];
    var bmss = data.find(item => item.bms !== undefined);
    var citys = data.find(item => item.city !== undefined);
    var oz_numbers = data.find(item => item.oz_number !== undefined);
    var cart_texts = data.find(item => item.cart_text !== undefined);
    if (qty > 0) {
      count++;
      $(this).parents('.subscription-card-product').find('.subscription-remove').removeClass('hidden');
      html += `<div class="subscription-cart-item" data-id="${product.id}">
        <div class="item-index">
          ${count}.
        </div>
        <div class="item-img">
          <img src="${product.featured_image}" alt="${product.title}" width="100" height="100">
        </div>
        <div class="item-content">
          <div class="item-content-head">
            <div class="item-info">
              <a href="/products/${product.handle}" class="item-title">${product.title}</a>
              <p class="text m-0">${ citys ? `${citys.city}, ` : `` }${ bmss ? `BMS Score: ${bmss.bms}` : `` }</p>
            </div>
            <div class="item-price">${Shopify.formatMoney(product.price)}</div>
          </div>
          ${ oz_numbers ? `<div class="item-content-bottom"><p class="oz m-0">${oz_numbers.oz_number}</p></div> ` : `` }
        </div>
      </div>`;

      reviewHtml += `<div class="subscription-cart-page-item" data-id="${product.id}">
        <div class="item-index">
          ${count}.
        </div>
        <div class="item-img">
          <img src="${product.featured_image}" alt="${product.title}" width="100" height="100">
        </div>
        <div class="item-content">
          <div class="item-content-head">
            <div class="item-info">
              <a href="/products/${product.handle}" class="item-title">${product.title}</a>
              ${ product.vendor != '' ? `<p class="text m-0">${product.vendor}</p>` : `` }
            </div>
            <div class="item-price-info right">
              <span class="item-price">${Shopify.formatMoney(product.price)}</span>
              ${ oz_numbers ? `<span class="oz">${oz_numbers.oz_number}</span>` : `` }
            </div>
          </div>
          <div class="item-content-bottom">
            <div class="subscription-qty-block">
              <button class="subscription-qty-btn minus">${minusIcon}</button>
              <input type="number" class="subscription-qty-input cart-qty" value="${qty}" data-id="${product.id}">
              <button class="subscription-qty-btn plus">${plusIcon}</button>
            </div>
            <a href="/" class="item-remove">
              ${removeIcon}
            </a>
          </div>
        </div>
      </div>`
    } else {
      $(this).parents('.subscription-card-product').find('.subscription-remove').addClass('hidden');
      $(this).parents('.subscription-card-product').find('.minus').addClass('disabled');
    }
  });
  $('[data-price]').html(Shopify.formatMoney(totalPrice));
  var discount = parseInt($('[data-subscription-collection]').attr('data-discount'));
  var finaTotalPrice = totalPrice;
  if (typeof $('[data-subscription-collection]').attr('data-discount') != 'undefined') {
    var discount_price = totalPrice * (discount / 100)
    $('[data-discount-price]').html(Shopify.formatMoney(discount_price));
    var finaTotalPrice = totalPrice - discount_price;
  }
  $('[data-final-price]').html(Shopify.formatMoney(finaTotalPrice));
  if (html != '') {
    $('[data-products]').html(html);
    $('[data-review-products]').html(reviewHtml);
  } else {
    $('.subscription-cart').removeClass('open-subscription-cart');
    $('body').removeClass('overflow-hidden');
    $('[data-products]').html('');
    $('[data-review-products]').html('<p class="center">Your cart is empty</p>');
  }
}

function checkQty() {
  var totalQty = 0;
  var packLimit = parseInt($('[data-subscription-collection]').attr('data-cuts'));
  $('[data-subscription-collection] .subscription-qty-input').each(function(i, v) {
    var qty = parseInt($(this).val());
    totalQty += qty;
  });
  $('.cut-count .count').html(totalQty);
  if (totalQty > packLimit) {
    $('.cut-count').addClass('alert');
  } else {
    $('.cut-count').removeClass('alert');
  }
  var p = (totalQty * 100) / packLimit;
  var r = packLimit - totalQty;
  if (totalQty >= packLimit) {
    // $('.cut-count').addClass('alert');
    $('[data-cart-checkout]').removeAttr('disabled');
    $('[data-cart-checkout]').removeClass('button--secondary');
    $('[data-checkout]').removeAttr('disabled');
    $('[data-checkout]').removeClass('button--secondary');
    $('[data-remain]').addClass('hidden');
    $('[data-progress]').addClass('hidden');
    $('[data-view-cuts]').removeAttr('disabled');
    $('[data-view-cuts]').removeClass('button--secondary');
    // $('[data-subscription-collection] .subscription-qty-block:not(.disabled) .plus').addClass('disabled');
    // $('[data-subscription-collection] .subscription-qty-block:not(.disabled) .plus').attr('disabled', 'disabled');
    // $('.subscription-cart-items .subscription-qty-block:not(.disabled) .plus').addClass('disabled');
    // $('.subscription-cart-items .subscription-qty-block:not(.disabled) .plus').attr('disabled', 'disabled');
    $('[data-progress]').css('--progress', p+'%');
    if (r == 1) {
      $('[data-remain]').html('Add <span class="r_count">'+r+'</span> more item');
    } else {
      $('[data-remain]').html('Add <span class="r_count">'+r+'</span> more items');
    }
  } else {
    if (totalQty > 0) {
      $('[data-view-cuts]').removeAttr('disabled');
      $('[data-view-cuts]').removeClass('button--secondary');
    } else {
      $('[data-view-cuts]').attr('disabled', 'disabled');
      $('[data-view-cuts]').addClass('button--secondary');
    }
    // $('.cut-count').removeClass('alert');
    $('[data-remain]').removeClass('hidden');
    $('[data-cart-checkout]').attr('disabled', 'disabled');
    $('[data-cart-checkout]').addClass('button--secondary');
    $('[data-checkout]').attr('disabled', 'disabled');
    $('[data-checkout]').addClass('button--secondary');
    $('[data-progress]').removeClass('hidden');
    // $('[data-subscription-collection] .subscription-qty-block:not(.disabled) .plus').removeClass('disabled');
    // $('[data-subscription-collection] .subscription-qty-block:not(.disabled) .plus').removeAttr('disabled');
    // $('.subscription-cart-items .subscription-qty-block:not(.disabled) .plus').removeClass('disabled');
    // $('.subscription-cart-items .subscription-qty-block:not(.disabled) .plus').removeAttr('disabled');
    
    $('[data-progress]').css('--progress', p+'%');
    if (r == 1) {
      $('[data-remain]').html('Add <span class="r_count">'+r+'</span> more item');
    } else {
      $('[data-remain]').html('Add <span class="r_count">'+r+'</span> more items');
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();
  
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if (this.input == document.querySelector('[data-sticky-qty]')) {
      document.querySelector('[data-main-qty]').value = this.input.value;
      document.querySelector('[data-main-qty]').dispatchEvent(this.changeEvent);
    }

    if (this.input == document.querySelector('[data-main-qty]')) {
      document.querySelector('[data-sticky-qty]').value = this.input.value;
      document.querySelector('[data-sticky-qty]').dispatchEvent(this.changeEvent);
    }

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details, .details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary, .summary').forEach((summary) => {
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    });
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]') || event.target.closest('.details.active');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary, .summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.classList.contains('menu-opening') || detailsElement.hasAttribute('open') || detailsElement.classList.contains('active');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        // detailsElement.classList.add('active');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // this.mainDetailsToggle.classList.remove('menu-opening');
    // this.mainDetailsToggle.classList.remove('active');
    this.mainDetailsToggle.querySelectorAll('details, .details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      // details.classList.remove('active');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if ((this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) || (this.mainDetailsToggle.classList.contains('menu-opening') && !this.mainDetailsToggle.contains(document.activeElement)))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details') || event.currentTarget.closest('.details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    // detailsElement.classList.remove('active');
    detailsElement.querySelector('summary, .summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary, .summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.classList.remove('menu-opening');
        if (detailsElement.closest('details[open]') || detailsElement.closest('.details.active')) {
          trapFocus(detailsElement.closest('details[open], .details.active'), detailsElement.querySelector('summary, .summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position',`${parseInt(this.header.offsetTop - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.swiper-slide')) {
          var product_recommendations = new Swiper("#product-recommendation-slider", {
            slidesPerView: 1.9,
            spaceBetween: 16,
            loop: true,
            centeredSlides: true,
            navigation: {
              nextEl: '#product-recommendation-slider .swiper-button-next',
              prevEl: '#product-recommendation-slider .swiper-button-prev',
            },
            pagination: {
              el: '#product-recommendation-slider .swiper-pagination',
              clickable: true,
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                slidesPerView: 4,
                spaceBetween: 24,
                centeredSlides: false,
                loop: false,
              }
            }
          });
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })
  
    observer.observe(options.element)
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  theme.TabImage = (function() {
    function TabImage(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.text-image-tab .text-image-tab-row');
      this.slideshow1 = container.querySelector('.text-image-tab .text-image-tab-media-slider');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    TabImage.prototype = Object.assign({}, TabImage.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
  
        var _this = this;
        if (slides.length > 1) {
          var text_image_tab_init = false;
          if (window.innerWidth <= 749) {
            if (!text_image_tab_init) {
              text_image_tab_init = true;
              this.swiper = new Swiper(this.slideshow, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                pagination: {
                  el: ".text-image-tab .swiper-action-bar .swiper-pagination",
                  clickable: true,
                },
                navigation: {
                  nextEl: '.text-image-tab .swiper-action-bar .swiper-button-next',
                  prevEl: '.text-image-tab .swiper-action-bar .swiper-button-prev',
                },
                mousewheel:{
                  forceToAxis: true
                }
              });
            }
          } else if (text_image_tab_init) {
            if (_this.swiper && typeof _this.swiper.destroy === 'function') {
              _this.swiper.destroy(false, true)
            }
            text_image_tab_init = false;
          }
          window.addEventListener("resize", function() {
            if (window.innerWidth <= 749) {
              if (!text_image_tab_init) {
                text_image_tab_init = true;
                _this.swiper = new Swiper(_this.slideshow, {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  loop: true,
                  pagination: {
                    el: ".text-image-tab .swiper-action-bar .swiper-pagination",
                    clickable: true,
                  },
                  navigation: {
                    nextEl: '.text-image-tab .swiper-action-bar .swiper-button-next',
                    prevEl: '.text-image-tab .swiper-action-bar .swiper-button-prev',
                  },
                  mousewheel:{
                    forceToAxis: true
                  }
                });
              }
            } else if (text_image_tab_init) {
              if (_this.swiper && typeof _this.swiper.destroy === 'function') {
                _this.swiper.destroy(false, true)
              }
              text_image_tab_init = false;
            }
          });
        } else {
          // Add loaded class to first slide
          // slides[0].classList.add('swiper-slide-active');
        }

        this.swiper1 = new Swiper(this.slideshow1, {
          slidesPerView: 'auto',
          effect: "coverflow",
          centeredSlides: true,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 400,
            modifier: 0.4
          },
          mousewheel:{
            forceToAxis: true
          },
          loop: false,
          on: {
            slideChange: function () {
              var currentSlide = this.slides[this.activeIndex],
                tab = currentSlide.dataset.tabMedia;
              $('.text-image-tab-toggler .tab-toggler[data-tab-target="'+tab+'"]').click();
            }
          }
        });

        $('.text-image-tab-toggler .tab-toggler').click(function(e) {
          e.preventDefault();
          $(this).addClass('active').siblings().removeClass('active');
          var tab = $(this).data('tab-target');
          $('.text-image-tab-wrap .text-image-tab-slide[data-tab-content="'+tab+'"]').fadeIn().siblings().hide();
          $('.text-image-tab-container .media-block figure[data-tab-media="'+tab+'"]').addClass('active').siblings().removeClass('active');
          
          var tab_media = tab.replace('tab____','');
          _this.swiper1.slideTo(tab_media-1, 400);
        });
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
        if (this.swiper1 && typeof this.swiper1.destroy === 'function') {
          this.swiper1.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
        if (this.swiper1 && typeof this.swiper1.play === 'function') {
          this.swiper1.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
        if (this.swiper1 && typeof this.swiper1.autoplay.running === 'function') {
          if (this.swiper1.autoplay) {
            this.swiper1.autoplay.start();
          }
        }
      }
    });
  
    return TabImage;
  })();

  theme.SubscriptionBanner = (function() {
    function SubscriptionBanner(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.subscription-banner-row .product-block-row');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SubscriptionBanner.prototype = Object.assign({}, SubscriptionBanner.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 1.5,
            spaceBetween: 12,
            loop: false,
            navigation: {
              nextEl: '.subscription-banner-row .product-block-row .swiper-button-next',
              prevEl: '.subscription-banner-row .product-block-row .swiper-button-prev',
            },
            pagination: {
              el: '.subscription-banner-row .product-block-row .swiper-pagination',
              clickable: true,
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                slidesPerView: 3,
                spaceBetween: 16
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
      }
    });
  
    return SubscriptionBanner;
  })();

  theme.ImageTextColumn = (function() {
    function ImageTextColumn(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.image-text-column .image-text-column-slider');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    ImageTextColumn.prototype = Object.assign({}, ImageTextColumn.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 1.2,
            spaceBetween: 16,
            loop: false,
            navigation: {
              nextEl: '.image-text-column .image-text-column-slider .swiper-button-next',
              prevEl: '.image-text-column .image-text-column-slider .swiper-button-prev',
            },
            pagination: {
              el: '.image-text-column .image-text-column-slider .swiper-pagination',
              clickable: true,
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                slidesPerView: 3,
                spaceBetween: 24
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
      }
    });
  
    return ImageTextColumn;
  })();

  theme.FeaturedCollectionTab = (function() {
    function FeaturedCollectionTab(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelectorAll('.featured-collections-tab .featured-collections-tab-product');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    FeaturedCollectionTab.prototype = Object.assign({}, FeaturedCollectionTab.prototype, {
      init: function() {
        $('.featured-collections-tab .tab-toggler').click(function(e) {
          e.preventDefault();
          var text = $(this).text();
          $(this).addClass('active').siblings().removeClass('active');
          $(this).parents('.tab-bar-wrap').removeClass('active').siblings('.tab-select-box').find('span').text(text);
          var tab = $(this).data('tab-target');
          $('.featured-collections-tab-wrap .featured-collections-tab-content[data-tab-content="'+tab+'"]').fadeIn().siblings().hide();
        });
        $('.featured-collections-tab .tab-select-box-wrap .tab-select-box').click(function () {
          $(this).siblings('.tab-bar-wrap').toggleClass('active');
        });
        $(document).mouseup(function(e){
          var container = $(".featured-collections-tab .tab-select-box-wrap");
          if (!container.is(e.target) && container.has(e.target).length === 0){
            container.find('.tab-bar-wrap').removeClass('active');
          }
        });
        $(this.slideshow).each(function() {
          var this_slider = $(this);
          var slides = this_slider[0].querySelectorAll('.swiper-slide');
          if (slides.length > 1) {
            var slider_pagination = $(this).find('.swiper-pagination')[0];
            var slider_prev = $(this).find('.swiper-button-prev')[0];
            var slider_next = $(this).find('.swiper-button-next')[0];
            
            if (window.innerWidth <= 989) {
              this.swiper = new Swiper(this_slider[0], {
                slidesPerView: 1.2,
                spaceBetween: 20,
                loop: true,
                centeredSlides: true,
                pagination: {
                el: slider_pagination,
                  clickable: true,
                },
                navigation: {
                  nextEl: slider_next,
                  prevEl: slider_prev,
                },
                mousewheel: {
                  forceToAxis: true
                },
                breakpoints: {
                  576: {
                    slidesPerView: 1.5,
                  },
                  750: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    loop: false,
                  }
                }
              });
            }
          }
        })
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
    });
  
    return FeaturedCollectionTab;
  })();

  theme.FeaturedCollection = (function() {
    function FeaturedCollection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.featured-collection .featured-collection-row');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    FeaturedCollection.prototype = Object.assign({}, FeaturedCollection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
        var _this = this;
        if (slides.length > 1) {
          var is_featured_collection_slider = false;
          if (window.innerWidth <= 989) {
            if (!is_featured_collection_slider) {
              is_featured_collection_slider = true;
              this.swiper = new Swiper(this.slideshow, {
                slidesPerView: 2,
                spaceBetween: 20,
                loop: false,
                pagination: {
                  el: ".featured-collection .swiper-action-bar .swiper-pagination",
                  clickable: true,
                },
                navigation: {
                  nextEl: '.featured-collection .swiper-action-bar .swiper-button-next',
                  prevEl: '.featured-collection .swiper-action-bar .swiper-button-prev',
                },
                mousewheel:{
                  forceToAxis: true
                },
                breakpoints: {
                  750: {
                    slidesPerView: 3,
                  }
                }
              });
            }
          } else if (is_featured_collection_slider) {
            if (_this.swiper && typeof _this.swiper.destroy === 'function') {
              _this.swiper.destroy(false, true)
            }
            is_featured_collection_slider = false;
          }
          window.addEventListener("resize", function() {
            if (window.innerWidth <= 989) {
              if (!is_featured_collection_slider) {
                is_featured_collection_slider = true;
                _this.swiper = new Swiper(_this.slideshow, {
                  slidesPerView: 2,
                  spaceBetween: 20,
                  loop: false,
                  pagination: {
                    el: ".featured-collection .swiper-action-bar .swiper-pagination",
                    clickable: true,
                  },
                  navigation: {
                    nextEl: '.featured-collection .swiper-action-bar .swiper-button-next',
                    prevEl: '.featured-collection .swiper-action-bar .swiper-button-prev',
                  },
                  mousewheel:{
                    forceToAxis: true
                  },
                  breakpoints: {
                    750: {
                      slidesPerView: 3,
                    }
                  }
                });
              }
            } else if (is_featured_collection_slider) {
              if (_this.swiper && typeof _this.swiper.destroy === 'function') {
                _this.swiper.destroy(false, true)
              }
              is_featured_collection_slider = false;
            }
          });
        } else {
          // Add loaded class to first slide
          // slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
    });
  
    return FeaturedCollection;
  })();

  theme.SubscriptionPackages = (function() {
    function SubscriptionPackages(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.subscription-packages-product');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SubscriptionPackages.prototype = Object.assign({}, SubscriptionPackages.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
        var _this = this;
        if (slides.length > 1) {
          this.swiper = new Swiper (this.slideshow, {
            slidesPerView: 2,
            spaceBetween: 16,
            loop: false,
            navigation: {
              nextEl: '.subscription-packages-'+_this.sectionId+' .swiper-button-next',
              prevEl: '.subscription-packages-'+_this.sectionId+' .swiper-button-prev',
            },
            pagination: {
              el: '.subscription-packages-'+_this.sectionId+' .swiper-pagination',
              clickable: true,
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              990: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              },
              1201: {
                slidesPerView: 3,
                spaceBetween: 24,
              }
            }
          });
        } else {
          // Add loaded class to first slide
          // slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
    });
  
    return SubscriptionPackages;
  })();

  theme.reviewSlider = (function() {
    function reviewSlider(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.customer-reviews .customer-reviews-row');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    reviewSlider.prototype = Object.assign({}, reviewSlider.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
  
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            loop: false,
            navigation: {
              nextEl: '.customer-reviews .swiper-button-next',
              prevEl: '.customer-reviews .swiper-button-prev',
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                spaceBetween: 42,
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
      }
    });
  
    return reviewSlider;
  })();

  theme.collectionBanner = (function() {
    function collectionBanner(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.collection-hero__inner .collection-hero-link-row');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    collectionBanner.prototype = Object.assign({}, collectionBanner.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
  
        if (slides.length > 1) {
          this.swiper = new Swiper(this.slideshow, {
            slidesPerView: 1,
            loop: false,
            pagination: {
              el: ".collection-hero__inner .collection-hero-link-row .swiper-pagination",
              clickable: true,
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                slidesPerView: 3,
              }
            }
          });
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('swiper-slide-active');
        }

        $('.collection-hero-link-row .collection-hero-link .read-more').click(function (e) {
          e.preventDefault();
          $(this).siblings('.content-wrap').slideDown();
          $(this).hide();
        });
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.swiper-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
          this.swiper.slideTo(index, 1000, false)
          this.swiper.autoplay.pause()
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.swiper && typeof this.swiper.autoplay.pause === 'function') {
              this.swiper.autoplay.pause()
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.swiper && typeof this.swiper.autoplay.running === 'function') {
          if (this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        }
      }
    });
  
    return collectionBanner;
  })();

  theme.RecentlyView = (function() {
    function RecentlyView(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.recently_view .recently_view-row');
      // if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      this.init();
  
    }
  
    RecentlyView.prototype = Object.assign({}, RecentlyView.prototype, {
      init: function() {
        var _this = this;
        if (productHandleQueue.length > 0 && productHandleQueue[0] != '') {
          $(this.container).show();
          $(productHandleQueue).each(function(i, v) {
            if (i <= 10 && v != '') {
              var hh = i;
              jQuery.ajax({
                dataType: 'html',
                url: '/products/' + productHandleQueue[i] + '?view=card',
                cache: false,
                success: function(data) {
                  var html = '';
                  html += '<div class="swiper-slide">',
                  html += data
                  html += '</div>'
                  $('.recently_view .swiper-wrapper').append(html);
                  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                },
                error: function() {
                  cookie.remove(productHandleQueue[i]);
                }
              });
            }
          })
          // if (productHandleQueue.length >= 2) {
          //   this.slideshow.querySelector('.swiper-action-bar').classList.remove('hidden');
          // } else {
          //   this.slideshow.querySelector('.swiper-action-bar').classList.add('hidden');
          // }
          _this.swiper = new Swiper(_this.slideshow, {
            slidesPerView: 1.9,
            spaceBetween: 16,
            loop: true,
            centeredSlides: true,
            navigation: {
              nextEl: '.recently_view .recently_view-row .swiper-button-next',
              prevEl: '.recently_view .recently_view-row .swiper-button-prev',
            },
            pagination: {
              el: '.recently_view .recently_view-row .swiper-pagination',
              clickable: true,
            },
            mousewheel:{
              forceToAxis: true
            },
            breakpoints: {
              750: {
                slidesPerView: 4,
                spaceBetween: 24,
                centeredSlides: false,
                loop: false,
              }
            }
          });
          
        } else {
          $(this.container).hide();
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
    });
  
    return RecentlyView;
  })();

  theme.FeaturedBlog = (function() {
    function FeaturedBlog(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('.featured-blog .featured-blog-slider');
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    FeaturedBlog.prototype = Object.assign({}, FeaturedBlog.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.swiper-slide');
        var _this = this;
        if (slides.length > 1) {
          var init = false;
          if (window.innerWidth >= 749) {
            if (!init) {
              init = true;
              this.swiper = new Swiper(this.slideshow, {
                slidesPerView: "auto",
                spaceBetween: 16,
                navigation: {
                  nextEl: '.featured-blog .featured-blog-slider .swiper-button-next',
                  prevEl: '.featured-blog .featured-blog-slider .swiper-button-prev',
                },
                mousewheel:{
                  forceToAxis: true
                },
                breakpoints: {
                  750: {
                    spaceBetween: 24,
                  }
                }
              });
            }
          } else if (init) {
            if (_this.swiper && typeof _this.swiper.destroy === 'function') {
              _this.swiper.destroy(false, true)
            }
            init = false;
          }
          window.addEventListener("resize", function() {
            if (window.innerWidth >= 749) {
              if (!init) {
                init = true;
                _this.swiper = new Swiper(_this.slideshow, {
                  slidesPerView: "auto",
                  spaceBetween: 16,
                  navigation: {
                    nextEl: '.featured-blog .featured-blog-slider .swiper-button-next',
                    prevEl: '.featured-blog .featured-blog-slider .swiper-button-prev',
                  },
                  mousewheel:{
                    forceToAxis: true
                  },
                  breakpoints: {
                    750: {
                      spaceBetween: 24,
                    }
                  }
                });
              }
            } else if (init) {
              if (_this.swiper && typeof _this.swiper.destroy === 'function') {
                _this.swiper.destroy(false, true)
              }
              init = false;
            }
          });
        } else {
          // Add loaded class to first slide
          // slides[0].classList.add('swiper-slide-active');
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(false, true)
        }
      },
  
      onDeselect: function() {
        if (this.swiper && typeof this.swiper.play === 'function') {
          this.swiper.init();
        }
      },
    });
  
    return FeaturedBlog;
  })();

  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }
  DOMready(function(){
    theme.sections = new theme.Sections();
  
    theme.sections.register('text-image-tab', theme.TabImage);
    theme.sections.register('subscription-banner', theme.SubscriptionBanner);
    theme.sections.register('image-text-column', theme.ImageTextColumn);
    theme.sections.register('featured-collections-tab', theme.FeaturedCollectionTab);
    theme.sections.register('featured-collection', theme.FeaturedCollection);
    theme.sections.register('subscription-packages', theme.SubscriptionPackages);
    theme.sections.register('customer-reviews', theme.reviewSlider);
    theme.sections.register('main-collection-banner', theme.collectionBanner);
    theme.sections.register('recently-view', theme.RecentlyView);
    theme.sections.register('featured-blog', theme.FeaturedBlog);
  });
})();

$(document).ready(function() {

  $('body').on('change', '[data-frequency-box]', function() {
    var parent = $(this).parents('[data-box]');
    var button = parent.find('[data-subscribe-button]');
    var currentUrl = button.attr('href');
    var newFrequency = parent.find('[data-frequency-box] input:checked').val();
    var updateUrl = currentUrl.replace(/frequency=\d+/, `frequency=${newFrequency}`);
    button.attr('href', updateUrl);
    var learnbutton = parent.find('[data-learnmore-button]');
    if($('[data-learnmore-button]').length){
      var learnUrl = learnbutton.attr('href');
      var updatelearnUrl = learnUrl.replace(/frequency=\d+/, `frequency=${newFrequency}`);
      learnbutton.attr('href', updatelearnUrl);
    }
    var id = parent.attr('data-id');
    var customizebutton = $('[data-customize][data-id="'+id+'"]');
    if($('[data-customize][data-id="'+id+'"]').length){
      var zlearnUrl = customizebutton.attr('href');
      var zupdatelearnUrl = zlearnUrl.replace(/frequency=\d+/, `frequency=${newFrequency}`);
      customizebutton.attr('href', zupdatelearnUrl);
    }
    var checkoutbutton = $('[data-cart-checkout][data-id="'+id+'"]');
    if($('[data-cart-checkout][data-id="'+id+'"]').length){
      var clearnUrl = checkoutbutton.attr('href');
      var cupdatelearnUrl = clearnUrl.replace(/frequency=\d+/, `frequency=${newFrequency}`);
      checkoutbutton.attr('href', cupdatelearnUrl);
    }
  });

  $('body').on('click', '[data-learnmore-button]', function(e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    $('.subscription-cart[data-id="'+id+'"]').addClass('open-subscription-cart');
    $('body').addClass('overflow-hidden');
  });
  
  $('body').on('click', '[data-subscription]', function(e) {
    e.preventDefault();
    var cuts = $('[name="cuts"]:checked').val();
    var frequency = $('[name="frequency"]:checked').val();
    var price = $('[name="cuts"]:checked').attr('data-price');
    var url = $(this).attr('href') + `?cuts=${cuts}&frequency=${frequency}&price=${price}`;
    window.location.href = url;
  });

  // if (window.location.search.indexOf('cuts') > -1 && window.location.search.indexOf('frequency') > -1) {
  //   if ($('[data-subscription-collection]').length) {
  //     var query = window.location.search;
  //     var params = new URLSearchParams(query);
  //     var cuts = params.get('cuts');
  //     var frequency = params.get('frequency');
  //     $('[data-subscription-collection]').attr('data-cuts', cuts);
  //     $('[data-subscription-collection]').attr('data-frequency', frequency);
  //     $('.cut-count .t_count').html(cuts);
  //   }
  // }

  $('body').on('click', '[data-subscription-collection] .subscription-qty-block .subscription-qty-btn', function() {
    var ip = parseInt($(this).parent().find('input').val());
    var id = $(this).parent().find('input').attr('data-id');
    if ($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip < 0) {
      ip = 0;
    }
    ip == 0 ? $(this).parent().find('.subscription-qty-btn.minus').addClass('disabled') : $(this).parent().find('.subscription-qty-btn.minus').removeClass('disabled')
    if (ip > 0) {
      $(this).parents('.subscription-card-product').addClass('selected');
    } else {
      $(this).parents('.subscription-card-product').removeClass('selected');
    }
    $(this).parent().find('input').val(ip).trigger('change');
  });

  $('body').on('click', '#subscription-cart-page .subscription-qty-block .subscription-qty-btn', function() {
    var ip = parseInt($(this).parent().find('input').val());
    var id = $(this).parent().find('input').attr('data-id');
    if ($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip < 0) {
      ip = 0;
    }
    ip == 0 ? $(this).parent().find('.subscription-qty-btn.minus').addClass('disabled') : $(this).parent().find('.subscription-qty-btn.minus').removeClass('disabled')
    $(this).parent().find('input').val(ip);
    if (ip > 0) {
      $('[data-subscription-collection] .subscription-qty-input[data-id="'+id+'"]').parents('.subscription-card-product').addClass('selected');
    } else {
      $('[data-subscription-collection] .subscription-qty-input[data-id="'+id+'"]').parents('.subscription-card-product').removeClass('selected');
    }
    $('[data-subscription-collection] .subscription-qty-input[data-id="'+id+'"]').val(ip).trigger('change');
  });

  $('body').on('click', '.item-remove', function(e) {
    e.preventDefault();
    $(this).parents('.subscription-cart-page-item').find('input').val(0)
    var id = $(this).parents('.subscription-cart-page-item').find('input').attr('data-id');
    $('[data-subscription-collection] .subscription-qty-input[data-id="'+id+'"]').val(0).trigger('change');
    $('[data-subscription-collection] .subscription-qty-input[data-id="'+id+'"]').parents('.subscription-card-product').removeClass('selected');
  });

  $('body').on('click', '.subscription-remove', function(e) {
    e.preventDefault();
    var id = $(this).parents('.subscription-card-product').find('input.subscription-qty-input').attr('data-id');
    $(this).parents('.subscription-card-product').find('input.subscription-qty-input').val(0).trigger('change');
    $(this).parents('.subscription-card-product').removeClass('selected');
  });

  $('body').on('change', '[data-subscription-collection] .subscription-qty-block .subscription-qty-input', function() {
    checkQty();
    addProductHtml();
  });

  $('body').on('click', '[data-customize][data-has]', function(e) {
    e.preventDefault();
    $('.subscription-cart').removeClass('open-subscription-cart');
    $('body').removeClass('overflow-hidden');
    $('[data-subscription-collection]').removeClass('hidden');
    $('.subscription-cart-page').addClass('hidden');
    $('[data-checkout]').addClass('hidden');
    $('[data-view-cuts]').removeClass('hidden');
    $('[data-back]').attr('data-review-has', 'no');
    $('.subscription-step:eq(1)').removeClass('active').addClass('current');
    $('.subscription-step:eq(2)').removeClass('current');
  });

  $('body').on('click', '[data-cart-checkout][data-has], [data-view-cuts]', function(e) {
    e.preventDefault();
    $('.subscription-cart').removeClass('open-subscription-cart');
    $('body').removeClass('overflow-hidden');
    $('[data-subscription-collection]').addClass('hidden');
    $('.subscription-cart-page').removeClass('hidden');
    $('[data-checkout]').removeClass('hidden');
    $('[data-view-cuts]').addClass('hidden');
    $('[data-back]').attr('data-review-has', 'yes');
    $('.subscription-step:eq(1)').removeClass('current').addClass('active');
    $('.subscription-step:eq(2)').addClass('current');
  });

  $('body').on('click', '[data-review-has="yes"]', function(e) {
    e.preventDefault();
    $('[data-subscription-collection]').removeClass('hidden');
    $('.subscription-cart-page').addClass('hidden');
    $('[data-checkout]').addClass('hidden');
    $('[data-view-cuts]').removeClass('hidden');
    $('[data-back]').attr('data-review-has', 'no');
    $('.subscription-step:eq(1)').removeClass('active').addClass('current');
    $('.subscription-step:eq(2)').removeClass('current');
  });

  function randomNumber(min, max) {  
    min = Math.ceil(min); 
    max = Math.floor(max); 
    return Math.floor(Math.random() * (max - min + 1)) + min; 
  }
  
  $('body').on('click', '[data-checkout]:not([disabled])', function(e) {
    e.preventDefault();
    var itemsToAdd = [];
    $('[data-checkout]').addClass('loading');
    $('.loading__spinner').removeClass('hidden');
    var sellingId = parseInt($('[data-subscription-collection]').attr('data-frequency'));
    var cuts = parseInt($('[data-subscription-collection]').attr('data-cuts'));
    var bundleId = randomNumber(100000000000, 10000000000000);
    $('[data-subscription-collection] .subscription-qty-input').each(function(i, v) {
      var qty = parseInt($(this).val());
      var parent = $(this).parents('.subscription-card-product');
      var product = JSON.parse(parent.find('[type="application/json"]').text())[0];
      let itemIndex = itemsToAdd.findIndex(item => item.id === product.variants[0].id);
      if (qty > 0) {
        if (itemIndex !== -1) {
          itemsToAdd[itemIndex].quantity = qty;
        } else {
          itemsToAdd.push({
            quantity: qty,
            id: product.variants[0].id,
            selling_plan: sellingId,
            properties: {
              '_bundleId': bundleId,
              '_box': cuts,
              'ProductId': product.id
            }
          });
        }
      } else {
        if (itemIndex !== -1) {
          itemsToAdd.splice(itemIndex, 1);
        }
      }
    });
    function giftCall() {
      window.location.href = '/checkout';
      $('[data-checkout]').removeClass('loading');
      $('.loading__spinner').addClass('hidden');
    }
    addCartItems(itemsToAdd, giftCall, true);
  });

  
});